export function getBase64String(data?: string) {
  if (data?.includes(';base64,')) {
    return data.split(';base64,')?.[1];
  }

  return data;
}
